'use client';

import { atomWithStorage, type CollectibleAuctionPostBid } from '@capsicum/common';

export const placeBidIdAtom = atomWithStorage<CollectibleAuctionPostBid['id']>('placeBidId', '');
